export enum UserSettingName {
  CovidCareAlerts = "COVID_CARE_ALERTS",
  DeviceStatusAlerts = "DEVICE_STATUS_ALERTS",
  AppAlerts = "APP_ALERTS",
  EmailAlerts = "EMAIL_ALERTS",
  DeviceOfflineEmailAlerts = "DEVICE_OFFLINE_EMAIL",
  UseV2Aggregates = "USE_V2_AGGREGATES"
}

export interface UserSetting {
  userId: string;
  name: UserSettingName;
  value: string;
}
